<script setup lang="ts">
import Button from 'primevue/button';

import CloseIcon from '../../assets/icons/close-tiny.svg?component';

defineOptions({ name: 'UiDialogCloseButton' });

interface Props {
  disabled?: boolean;
  label?: string;
}

const { disabled = false, label = 'Close' } = defineProps<Props>();

const emit = defineEmits<{
  click: [];
}>();
</script>

<template>
  <div class="ui-dialog-close-button">
    <Button
      type="button"
      severity="secondary"
      variant="text"
      rounded
      class="ui-dialog-close-button__button"
      :disabled="disabled"
      :aria-label="label"
      @click="emit('click')"
    >
      <template #icon>
        <CloseIcon />
      </template>
    </Button>
  </div>
</template>

<style scoped lang="scss">
.ui-dialog-close-button {
  position: absolute;
  top: $static-space-3;
  right: $static-space-3;
  z-index: 10;
  display: flex;
  justify-content: center;
  width: 2.1875rem;
  height: $static-space-8;

  &__button {
    width: $static-space-8;
    height: $static-space-8;
    padding: 0;
    color: var(--p-surface-500);
  }

  :deep(svg) {
    width: $static-text-sm;
    height: $static-text-sm;
  }
}
</style>
